/* Recebe um valor, e força ele esteja entre um valor mínimo
  e um valor máximo;
  Exemplo: constrain(5, 10, 15) retorna 10 */
export function constrain (val: number, min: number, max: number) {
  if (val < min) return min
  if (val > max) return max
  return val
}
